import React from "react";

// import { FilterCheckBox, FilterTabs, FilterRadio, FilterDate } from "../Filters";


export const FormInputPassword = props => <>
  <label for="e-input-3"><strong>{props.label} {props.required ? <i class="color-categorical-5">*</i> : null}</strong></label>
  {props.required ? <input type="password"
    placeholder={props.placeholder}
    id={props.id}
    name={props.name}
    value={props.value}
    disabled={props.disabled}
    onChange={props.onChange} required /> : <input type="password"
      placeholder={props.placeholder}
      id={props.id}
      name={props.name}
      value={props.value}
      disabled={props.disabled}
      onChange={props.onChange} />}
</>
